module.exports = __webpack_public_path__ + "static/media/step-customer-icon.4fec2134.svg";